import React, { PropTypes } from 'react';

const intlImgStyle = {
    maxWidth: '65%',
    maxHeight: '55%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

const intlAnchorStyle = {
    height: '50px',
    display: 'block'
};

const Tier1Provider = ({ isIntl, provider, providerSelect }) => {
    const { images: { picker: { href: providerImageUrl = '' } }, appLink } = provider;
    let clickHandler;
    let href = appLink;
    let anchorStyle;
    let imgStyle;
    if (providerSelect) {
        clickHandler = (event) => { event.preventDefault(); return providerSelect(provider); };
        href = null;
    }
    // Override style for intl tier one providers
    if (isIntl) {
        anchorStyle = intlAnchorStyle;
        imgStyle = intlImgStyle;
    }

    return (
        <li onClick={clickHandler}>
            <a style={anchorStyle} href={href}><img style={imgStyle} src={providerImageUrl} alt={provider.name} /></a>
        </li>
    );
};

Tier1Provider.propTypes = {
    isIntl: PropTypes.bool,
    provider: PropTypes.object,
    providerSelect: PropTypes.func
};

export default Tier1Provider;



// WEBPACK FOOTER //
// ./app/common/chooseProvider/Tier1Provider.js